function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.293 20.293a1 1 0 001.414 1.414l-1.414-1.414zm9.414-6.586a1 1 0 00-1.414-1.414l1.414 1.414zm-1.414 8a1 1 0 001.414-1.414l-1.414 1.414zm-6.586-9.414a1 1 0 00-1.414 1.414l1.414-1.414zm0 9.414l8-8-1.414-1.414-8 8 1.414 1.414zm8-1.414l-8-8-1.414 1.414 8 8 1.414-1.414z",
  fill: "#9CA6B0",
  opacity: 0.65
});
function SvgCloseGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none"
  }, props), _ref);
}
export default SvgCloseGray;